// Generated by scripts/generate-audio.py. See docs/audio-assets.md.
import { ORDINARY_RECORDINGS } from './ordinary-recordings.js';
import { EXAM_RECORDINGS } from './exam-recordings.js';
export const RECORDINGS = {
    ...ORDINARY_RECORDINGS,
    ...EXAM_RECORDINGS,
    'A.': {
        file: '80d5a5c6.mp3',
        durationMs: 720,
    },
    'B.': {
        file: '02dd2e31.mp3',
        durationMs: 816,
    },
    'C.': {
        file: 'a0da5554.mp3',
        durationMs: 816,
    },
    'D.': {
        file: '22ce5607.mp3',
        durationMs: 816,
    },
    'Sound is on. You are ready to play.': {
        file: 'b4e202d8.mp3',
        durationMs: 2160,
    },
    'The apple with wings is raising one hand.': {
        file: '8a7aa8e2.mp3',
        durationMs: 2592,
    },
    'The apple with wings is raising both hands.': {
        file: '2a4673d2.mp3',
        durationMs: 2664,
    },
    'The carrot with wings is raising one hand.': {
        file: 'b62ad4fd.mp3',
        durationMs: 2520,
    },
    'The carrot with wings is raising both hands.': {
        file: '148d04e9.mp3',
        durationMs: 2640,
    },
    'The round clock is on the wall.': {
        file: '55815a72.mp3',
        durationMs: 1824,
    },
    'The square clock is on the wall.': {
        file: '1b601c0d.mp3',
        durationMs: 1776,
    },
    'The round clock is on the table.': {
        file: 'eceadd7a.mp3',
        durationMs: 1920,
    },
    'The square clock is on the table.': {
        file: '5b2b2a47.mp3',
        durationMs: 1824,
    },
    'The cat is sleeping on the chair, next to a ball.': {
        file: '26b3c75c.mp3',
        durationMs: 2616,
    },
    'The cat is sleeping on the chair, next to a fish.': {
        file: 'e3e37a99.mp3',
        durationMs: 2592,
    },
    'The cat is sleeping under the chair, next to a ball.': {
        file: 'aa346653.mp3',
        durationMs: 2784,
    },
    'The cat is sleeping under the chair, next to a fish.': {
        file: '8c2be502.mp3',
        durationMs: 2736,
    },
    'The apple is on the table.': {
        file: 'ce24959c.mp3',
        durationMs: 1656,
    },
    'The pear is on the table.': {
        file: '806a5b74.mp3',
        durationMs: 1512,
    },
    'The apple is under the table.': {
        file: 'd843ac35.mp3',
        durationMs: 1776,
    },
    'The pear is under the table.': {
        file: 'a538844d.mp3',
        durationMs: 1608,
    },
    'The cup is on the table.': {
        file: '201ad638.mp3',
        durationMs: 1584,
    },
    'The bottle is on the table.': {
        file: '13718eac.mp3',
        durationMs: 1656,
    },
    'The cup is under the table.': {
        file: '583c0e59.mp3',
        durationMs: 1608,
    },
    'The bottle is under the table.': {
        file: 'b5da74e5.mp3',
        durationMs: 1776,
    },
    'The star is on the table.': {
        file: '6bf4f4bc.mp3',
        durationMs: 1584,
    },
    'The heart is on the table.': {
        file: '0472d2f0.mp3',
        durationMs: 1704,
    },
    'The star is under the table.': {
        file: '1bf11755.mp3',
        durationMs: 1656,
    },
    'The heart is under the table.': {
        file: '4343dff1.mp3',
        durationMs: 1776,
    },
    'The star is on the top shelf.': {
        file: '631bf431.mp3',
        durationMs: 1776,
    },
    'The heart is on the top shelf.': {
        file: '0f191655.mp3',
        durationMs: 1800,
    },
    'The star is on the bottom shelf.': {
        file: '1d22cb25.mp3',
        durationMs: 1896,
    },
    'The heart is on the bottom shelf.': {
        file: '43ed9b89.mp3',
        durationMs: 1896,
    },
    'The circle is on the top shelf.': {
        file: 'd9639f25.mp3',
        durationMs: 1872,
    },
    'The triangle is on the top shelf.': {
        file: 'a132737d.mp3',
        durationMs: 2016,
    },
    'The circle is on the bottom shelf.': {
        file: '5325bc39.mp3',
        durationMs: 2016,
    },
    'The triangle is on the bottom shelf.': {
        file: 'ca0d0341.mp3',
        durationMs: 2208,
    },
    'The flower is on the top shelf.': {
        file: '21d2fc28.mp3',
        durationMs: 1824,
    },
    'The moon is on the top shelf.': {
        file: '510720aa.mp3',
        durationMs: 1704,
    },
    'The flower is on the bottom shelf.': {
        file: '30ab327a.mp3',
        durationMs: 1944,
    },
    'The moon is on the bottom shelf.': {
        file: '03f2d078.mp3',
        durationMs: 1824,
    },
    'There is one round balloon above the gift.': {
        file: '8faa2576.mp3',
        durationMs: 2256,
    },
    'There is one heart-shaped balloon above the gift.': {
        file: 'ba13f05c.mp3',
        durationMs: 2736,
    },
    'There are two round balloons above the gift.': {
        file: '07aafe9d.mp3',
        durationMs: 2304,
    },
    'There are two heart-shaped balloons above the gift.': {
        file: '737d50a3.mp3',
        durationMs: 2640,
    },
    'There is one star-shaped balloon above the gift.': {
        file: '1aa0aca2.mp3',
        durationMs: 2640,
    },
    'There are two star-shaped balloons above the gift.': {
        file: '0020af31.mp3',
        durationMs: 2640,
    },
    'The sign with a star points to the left.': {
        file: 'cc5f9486.mp3',
        durationMs: 2208,
    },
    'The sign with a heart points to the left.': {
        file: '6daac662.mp3',
        durationMs: 2184,
    },
    'The sign with a star points to the right.': {
        file: '89de3815.mp3',
        durationMs: 2160,
    },
    'The sign with a heart points to the right.': {
        file: 'ab122859.mp3',
        durationMs: 2136,
    },
    'The sign with a circle points to the left.': {
        file: '995add32.mp3',
        durationMs: 2256,
    },
    'The sign with a triangle points to the left.': {
        file: 'b1dd1a2a.mp3',
        durationMs: 2472,
    },
    'The sign with a circle points to the right.': {
        file: '7dba80a9.mp3',
        durationMs: 2208,
    },
    'The sign with a triangle points to the right.': {
        file: 'ebf34e41.mp3',
        durationMs: 2352,
    },
    'The sign with a flower points to the left.': {
        file: 'df893e95.mp3',
        durationMs: 2280,
    },
    'The sign with a moon points to the left.': {
        file: '95b344c7.mp3',
        durationMs: 2184,
    },
    'The sign with a flower points to the right.': {
        file: '46f013bc.mp3',
        durationMs: 2232,
    },
    'The sign with a moon points to the right.': {
        file: 'a5da4cf6.mp3',
        durationMs: 2160,
    },
    'There is one apple in the basket.': {
        file: '3357fd05.mp3',
        durationMs: 1896,
    },
    'There is one pear in the basket.': {
        file: '8a317bc3.mp3',
        durationMs: 1776,
    },
    'There are two apples in the basket.': {
        file: 'a47f1f76.mp3',
        durationMs: 1824,
    },
    'There are two pears in the basket.': {
        file: '79bd767c.mp3',
        durationMs: 1800,
    },
    'There is one star in the basket.': {
        file: 'b1d72e3f.mp3',
        durationMs: 1848,
    },
    'There is one heart in the basket.': {
        file: '8d894211.mp3',
        durationMs: 1848,
    },
    'There are two stars in the basket.': {
        file: '7df7db94.mp3',
        durationMs: 1872,
    },
    'There are two hearts in the basket.': {
        file: '2da2ac06.mp3',
        durationMs: 1776,
    },
    'There is one circle in the basket.': {
        file: '43af0acf.mp3',
        durationMs: 1968,
    },
    'There is one triangle in the basket.': {
        file: '429bedab.mp3',
        durationMs: 2112,
    },
    'There are two circles in the basket.': {
        file: '3e43fde0.mp3',
        durationMs: 1944,
    },
    'There are two triangles in the basket.': {
        file: 'a3275b14.mp3',
        durationMs: 2064,
    },
    'The triangular flag has one star.': {
        file: 'cba3c8ef.mp3',
        durationMs: 2376,
    },
    'The triangular flag has two stars.': {
        file: 'e17fffd8.mp3',
        durationMs: 2352,
    },
    'The rectangular flag has one star.': {
        file: 'c69d4e18.mp3',
        durationMs: 2232,
    },
    'The rectangular flag has two stars.': {
        file: '6252512d.mp3',
        durationMs: 2256,
    },
    'The triangular flag has one heart.': {
        file: '926237b9.mp3',
        durationMs: 2400,
    },
    'The triangular flag has two hearts.': {
        file: '8b1209fa.mp3',
        durationMs: 2304,
    },
    'The rectangular flag has one heart.': {
        file: 'e1489d44.mp3',
        durationMs: 2328,
    },
    'The rectangular flag has two hearts.': {
        file: '39e90151.mp3',
        durationMs: 2184,
    },
    'The triangular flag has one circle.': {
        file: 'f1ec0d83.mp3',
        durationMs: 2520,
    },
    'The triangular flag has two circles.': {
        file: '939faf20.mp3',
        durationMs: 2544,
    },
    'The rectangular flag has one circle.': {
        file: 'a5826a50.mp3',
        durationMs: 2424,
    },
    'The rectangular flag has two circles.': {
        file: '1ecb3009.mp3',
        durationMs: 2376,
    },
    'There is one star beside the full moon.': {
        file: '544079fa.mp3',
        durationMs: 2184,
    },
    'There are two stars beside the full moon.': {
        file: '9035b73b.mp3',
        durationMs: 2208,
    },
    'There is one star beside the crescent moon.': {
        file: 'df849d1c.mp3',
        durationMs: 2352,
    },
    'There are two stars beside the crescent moon.': {
        file: '0aa0f239.mp3',
        durationMs: 2472,
    },
    'There is one cloud beside the full moon.': {
        file: 'd74a5a15.mp3',
        durationMs: 2304,
    },
    'There are two clouds beside the full moon.': {
        file: 'de5afae6.mp3',
        durationMs: 2184,
    },
    'There is one cloud beside the crescent moon.': {
        file: 'a55c81a3.mp3',
        durationMs: 2448,
    },
    'There are two clouds beside the crescent moon.': {
        file: '3bbcb9c8.mp3',
        durationMs: 2424,
    },
    'There is one bird beside the full moon.': {
        file: 'f970d7e9.mp3',
        durationMs: 2160,
    },
    'There are two birds beside the full moon.': {
        file: 'a6b69b7e.mp3',
        durationMs: 2160,
    },
    'There is one bird beside the crescent moon.': {
        file: '81e06477.mp3',
        durationMs: 2352,
    },
    'There are two birds beside the crescent moon.': {
        file: 'e9b14970.mp3',
        durationMs: 2304,
    },
};
//# sourceMappingURL=recordings.js.map